const setupTagsDropdowns = () => {
  $('select[name=tags]').parent().addClass('search').dropdown({
    allowAdditions: true,
    hideAdditions: false
  });
};

const removeEmptyTag = () => {
  $('select[name=tags] option[value=""]').remove();
};

window.setupTagsDropdowns = setupTagsDropdowns;
window.removeEmptyTag = removeEmptyTag;
